import http from '../../services/http/index';
import forResponse from '../../utils/forResponse';
import { FANCLUB_PURCHASE_INFO_URL } from '../../constants/apiUrls/apiUrls';

export const getFanclubPurchaseInfo = (anchorId, username) => {
  const url = FANCLUB_PURCHASE_INFO_URL.
    replace('{anchorId}', encodeURIComponent(anchorId)).
    replace('{username}', encodeURIComponent(username));

  return forResponse(http.get(url));
};
